<form class="gap-lg mt-lg grid" [formGroup]="form">
  <div hlmField>
    <label hlmFieldLabel for="input-nom">Nom du groupe</label>
    <input id="input-nom" hlmInput type="text" formControlName="nom" />
    @if (form.get('nom')?.hasError('notUnique')) {
      <hlm-field-error>Ce nom de groupe existe déjà.</hlm-field-error>
    }
  </div>

  <div hlmField>
    <label hlmFieldLabel for="input-duree">Nombre d'étapes possibles</label>
    <input id="input-duree" hlmInput type="number" formControlName="duree" step="1" />
  </div>
</form>
